export default __webpack_public_path__ + "static/bg_glosario-c8d155c38f0cf8c75f4958a76b914e8f.jpg";